/**
 * @generated SignedSource<<ce6a4bfade44ccac13b811a18599cf06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ClientRequest, ClientQuery } from 'relay-runtime';
export type jwtEnvironment_LocalDataQuery$variables = Record<PropertyKey, never>;
export type jwtEnvironment_LocalDataQuery$data = {
  readonly relay: {
    readonly queries: ReadonlyArray<{
      readonly __typename: "RelayQuery";
    }>;
    readonly subscriptions: ReadonlyArray<{
      readonly __typename: "ActiveSubscription";
    }>;
  };
};
export type jwtEnvironment_LocalDataQuery = {
  response: jwtEnvironment_LocalDataQuery$data;
  variables: jwtEnvironment_LocalDataQuery$variables;
};

const node: ClientRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "RelayQuery",
  "kind": "LinkedField",
  "name": "queries",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "jwtEnvironment_LocalDataQuery",
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Relay",
            "kind": "LinkedField",
            "name": "relay",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ActiveSubscription",
                "kind": "LinkedField",
                "name": "subscriptions",
                "plural": true,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "jwtEnvironment_LocalDataQuery",
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Relay",
            "kind": "LinkedField",
            "name": "relay",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ActiveSubscription",
                "kind": "LinkedField",
                "name": "subscriptions",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a254d569bfaf6bb4a032642bfabbc4dc",
    "id": null,
    "metadata": {},
    "name": "jwtEnvironment_LocalDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4f17c78c0a0b492c1d3a65f316a3d25f";

export default node;
